export const URLS = {
    SCIM: '/integrations/scim',
    SCIM_LIST: '/integrations/scim/list',
    SUBSCRIPTIONS: '/integrations/endpoint-lifecycle',
    V6_VWAN: '/integrations/virtual-wan',
    OLD_SUBSCRIPTIONS: '/app-subscriptions',
    CLIENT_SYNC_AAD: '/integrations/aad',
    CLIENT_SYNC_AD: '/integrations/ad',
    NETWORK: '/app-networks',
    OLD_NETWORK: '/networks',
    OLD_NETWORK_LIST: '/networks/list',
    GATEWAYS: '/endpoints/gateways',
    OLD_GATEWAYS: '/gateways',
    OLD_OLD_GATEWAYS: '/app-gateways',
    CLIENTS: '/endpoints/clients',
    OLD_CLIENTS: '/clients',
    OLD_OLD_CLIENTS: '/app-clients',
    SERVICES: '/connections/services',
    OLD_SERVICES: '/services',
    OLD_OLD_SERVICES: '/app-services',
    APPWANS: '/connections/appwans',
    OLD_APPWANS: '/appwans',
    OLD_OLD_APPWANS: '/app-appwans',
    SETTINGS: '/organizations/settings',
    ORG_SETTINGS: '/organizations/org-settings',
    OLD_SETTINGS: '/settings',
    OLD_OLD_SETTINGS: '/app-settings',
    GROUPS: '/endpoints/groups',
    OLD_GROUPS: '/groups',
    OLD_OLD_GROUPS: '/app-groups',
    HOME: '/main',
    OLD_HOME: '/app-main',
    LOGIN: '/login',
    OLD_LOGIN: '/app-login',
    LOGS: '/logs',
    OLD_LOGS: '/app-logs',
    CLOUD_ZITI_USERS: '/user-identities/users',
    CLOUD_ZITI_INVITATIONS: '/user-identities/invitations',
    USER: '/user-identities/user',
    USERS: '/user-identities/users',
    // The redesigned list's old URL; it redirects to USER_ROLES.
    ORGANIZATION_ROLES: '/user-identities/roles',
    USER_ROLES: '/user-identities/user-roles',
    CLOUD_ZITI_USERS_ROLES: '/user-identities/user-roles',
    USER_ROLES_LIST: '/user-identities/user-roles/list',
    USERS_LIST: '/user-identities/users/list',
    OLD_USERS: '/users',
    OLD_OLD_USERS: '/app-users',
    RESOURCE_USAGE: '/reporting/resource-usage',
    OLD_RESOURCE_USAGE: '/reporting',
    DAILYSTATS: '/reporting/dailystats',
    OLD_DAILYSTATS: '/dailystats',
    MANAGE_INVITATIONS: '/user-identities/invitations',
    MANAGE_INVITATIONS_LIST: '/user-identities/invitations/list',
    OLD_MANAGE_INVITATIONS: '/manage-invitations',
    ROLE_TEMPLATES: '/user-identities/role-templates',
    ROLE_TEMPLATES_LIST: '/user-identities/role-templates/list',
    ROLE_TEMPLATES_CREATE: '/user-identities/role-templates/create',
    PROFILE: '/profile',
    OLD_PROFILE: '/app-profile',
    PAGENOTFOUND: '/page-not-found',
    COLLECTORS: '/collectors',
    ALERTS: '/alerts',
    MUTES: '/alerts/mutes',
    LATENCY_POLICIES: '/alerts/latency-policies',
    LATENCY_POLICY_CREATE: '/alerts/latency-policies/create',
    OFFLINE_POLICIES: '/alerts/offline-policies',
    OFFLINE_POLICY_CREATE: '/alerts/offline-policies/create',
    PROCESS_EXECUTIONS: '/process-executions',
    PROCESS_EXECUTIONS_LIST: '/process-executions/list',
    CUSTOMER_PROCESS_EXECUTIONS: '/customers/customer-process-executions',
    ATTRIBUTES_EXPLORER: '/attributes-explorer',
    NOTIFICATIONS: '/notifications',
    NOTIFICATIONS_LIST: '/notifications/list',
    PASSWORD: '/app-password',
    BRANDING: '/branding',
    OLD_BRANDING: '/app-branding',
    USER_SETTINGS: '/user-settings',
    MANAGEMENT_EVENTS: '/management-events',
    MANAGEMENT_EVENTS_LIST: '/management-events/list',
    FABRIC_LATENCY: '/fabric-latency',
    CONTROLLER_LATENCY: '/controller-latency',
    FABRIC_LATENCY_TIMEOUTS: '/fabric-latency-timeouts',
    NETWORK_EVENTS: '/network-events',
    NETWORK_EVENTS_LIST: '/network-events/list',
    OLD_EVENTS: '/app-events',
    V7EVENTS: '/v7/events',
    ALARMS: '/alarms',
    OLD_ALARMS: '/app-alarms',
    VIRTUALWANSITES: '/endpoints/azure-virtual-wan-sites',
    OLD_VIRTUALWANSITES: '/azure-virtual-wan-sites',
    VIRTUALWANS: '/virtualwans',
    OLD_VIRTUALWANS: '/app-virtualwans',
    ERRORS: '/error-history',
    BILLING: '/billing',
    BILLING_DASHBOARD: '/billing/dashboard',
    ORG_BILLING: '/organization/billing',
    SUPPORT_BILLING: '/support/billing',
    CLOUD_ZITI_TOKENS: '/user-identities/tokens',
    TOKENS: '/user-identities/tokens',
    TOKENS_LIST: '/user-identities/tokens/list',
    OLD_TOKENS: '/tokens',
    ORGANIZATIONS: '/organizations/manage',
    ORGANIZATIONS_LIST: '/organizations/manage/list',
    OIDC_AUDIENCES: '/oidc-audiences',
    OIDC_AUDIENCES_LIST: '/oidc-audiences/list',
    OIDC_PUBLIC_CLIENTS: '/oidc-public-clients',
    OIDC_ISSUERS: '/oidc-issuers',
    OIDC_ISSUERS_LIST: '/oidc-issuers/list',
    OIDC_IDENTITY_AUDIENCE_MAP: '/oidc-identity-audience-map',
    OIDC_IDENTITY_AUDIENCE_MAP_LIST: '/oidc-identity-audience-map/list',
    OIDC_PUBLIC_CLIENT_ORG_MAPPING: '/public-client-org-map',
    OIDC_PUBLIC_CLIENT_ORG_MAPPING_LIST: '/public-client-org-map/list',
    OLD_ORGANIZATIONS: '/organizations',
    NETWORK_GROUPS: '/network-groups',
    NETWORK_GROUP_SUMMARY: '/reporting/network-group-summary',
    OLD_NETWORK_GROUP_SUMMARY: '/network-group-summary',
    DAILY_ENDPOINT_UTILIZATION: '/reporting/daily-endpoint-utilization',
    OLD_DAILY_ENDPOINT_UTILIZATION: '/daily-endpoint-utilization',
    CERTIFICATE_AUTHORITIES: '/certificate-authorities',
    ZITIAPPS: '/v7/connections/appwans',
    OLD_ZITIAPPS: '/v7/appwans',
    ZITIENDPOINTS: '/v7/endpoints',
    ZITIROUTERS: '/v7/routers',
    ZITIPOLICIES: '/v7/policies',
    ZITI_SERVICE_ER_POLICIES: '/v7/service-edge-router-policies',
    ZITISERVICES: '/v7/connections/services',
    ZITICONFIGS: '/v7/connections/configs',
    ZITICONFIGTYPES: '/v7/connections/config-types',
    ROLES: '/roles',
    PAYMENT_PROFILE: '/payment-profile',
    ACCOUNT_DETAILS: '/account-details',
    BILLING_SUBSCRIPTIONS: '/billing-subscriptions',
    BILLING_SUBSCRIPTION_OVERAGES: '/billing-subscription-overages',
    BILLING_SUBSCRIPTION_INVOICES: '/billing-subscription-invoices',
    BILLING_SUBSCRIPTION_USAGE: '/billing-subscription-usage',
    BILLING_SUBSCRIPTION_USAGE_REPORT: '/billing-subscription-usage-report',
    BILLING_PAYMENT_PROFILE: '/billing/payment-profile',
    BILLING_ACCOUNT_DETAILS: '/billing/account-details',
    APP_BILLING_SUBSCRIPTIONS: '/billing/billing-subscriptions',
    APP_BILLING_SUBSCRIPTION_OVERAGES: '/billing/billing-subscription-overages',
    APP_BILLING_SUBSCRIPTION_INVOICES: '/billing/billing-subscription-invoices',
    APP_BILLING_SUBSCRIPTION_USAGE: '/billing/billing-subscription-usage',
    APP_BILLING_SUBSCRIPTION_USAGE_REPORT: '/billing/billing-subscription-usage-report',
    ORG_PAYMENT_PROFILE: '/organization/payment-profile',
    ORG_ACCOUNT_DETAILS: '/organization/account-details',
    ORG_BILLING_SUBSCRIPTIONS: '/organization/billing-subscriptions',
    ORG_BILLING_SUBSCRIPTION_OVERAGES: '/organization/billing-subscription-overages',
    ORG_BILLING_SUBSCRIPTION_USAGE: '/organization/billing-subscription-usage',
    ORG_BILLING_SUBSCRIPTION_USAGE_REPORT: '/organization/billing-subscription-usage-report',
    SUPPORT_PAYMENT_PROFILE: '/support/payment-profile',
    SUPPORT_ACCOUNT_DETAILS: '/support/account-details',
    SUPPORT_BILLING_SUBSCRIPTIONS: '/support/billing-subscriptions',
    SUPPORT_BILLING_SUBSCRIPTION_OVERAGES: '/support/billing-subscription-overages',
    SUPPORT_BILLING_SUBSCRIPTION_USAGE: '/support/billing-subscription-usage',
    SUPPORT_BILLING_SUBSCRIPTION_USAGE_REPORT: '/support/billing-subscription-usage-report',
    GETTING_STARTED: '/getting-started',
    SAMPLE_SERVICE: '/getting-started/sample-service',
    OLD_ZITISERVICES: '/v7/services',
    V7DASHBOARD: '/v7/dashboard',
    NETWORKS6: '/networks6',
    NETWORKS_COMBINED: '/networks-combined',
    NETWORK_CONTROLLERS: '/network-controllers',
    NETWORK_CONTROLLERS_LIST: '/network-controllers/list',
    ALLOCATED_IPS: '/allocated-ips',
    ALLOCATED_IPS_LIST: '/allocated-ips/list',
    STORED_SECRETS: '/stored-secrets',
    STORED_SECRETS_LIST: '/stored-secrets/list',
    ZITI_CERTIFICATE_AUTHORITIES: '/v7/certificate-authorities',
    IDENTITIES_BASE: '/user-identities',
    POSTURE_CHECKS: '/posture-checks',
    TOPOLOGY: '/v7/topology',
    METRICS: '/v7/metrics',
    // routes that can be accessed without authorization
    INVITATION: '/invitation',
    OLD_INVITATION: '/app-invitation',
    CALLBACK: '/callback',
    AUTH_POLICIES: '/auth-policies',
    JWT_SIGNERS: '/jwt-signers',
    SUPPORT_OPERATIONS: '/support-operations',
    CUSTOMERS: '/customers',
    CUSTOMERS_ONBOARD: '/customers/onboard',
    CUSTOMERS_LIST: '/customers/list',
    CUSTOMER_PROCESS_EXECUTIONS_LIST: '/customers/customer-process-executions/list',
    TRAFFIC_ANALYSIS: '/traffic-analysis',
    MICROSEGMENTS: '/microsegments',
    SERVICE_SELECT: '/services/select',
    SERVICE_SIMPLE: '/services/simple',
    SERVICE_CREATE_FROM_TRAFFIC: '/services/create-from-traffic',
    SERVICE_SOURCE_IDENTITIES: '/services/source-identities',
    SERVICE_TEMPLATE: '/services/template',
    // The FD sub-app: Frontdoor on the v3 API. Its own prefix while it runs beside the v1/v2
    // Frontdoor below, which it is meant to replace.
    FD: '/fd',
    FD_DASHBOARD: '/fd/dashboard',
    FD_HTTP_SHARES: '/fd/http-shares',
    FD_HTTP_SHARES_CREATE: '/fd/http-shares/create',
    // The second tab of the HTTP section, so it sits below that path.
    FD_DOMAIN_NAMES: '/fd/http-shares/domain-names',
    FD_DOMAIN_NAMES_CREATE: '/fd/http-shares/domain-names/create',
    // The third tab of the HTTP section: the identity providers a share can log users in with.
    FD_OIDC_PROVIDERS: '/fd/http-shares/oidc-providers',
    FD_OIDC_PROVIDERS_CREATE: '/fd/http-shares/oidc-providers/create',
    FD_TCP_SHARES: '/fd/tcp-shares',
    FD_TCP_SHARES_CREATE: '/fd/tcp-shares/create',
    // Two more tabs of the TCP Shares ribbon, therefore, they sit below that path and not beside it.
    FD_TCP_SHARES_CERTIFICATES: '/fd/tcp-shares/certificates',
    FD_TCP_SHARES_CERTIFICATES_CREATE: '/fd/tcp-shares/certificates/create',
    FD_TCP_SHARES_TOKENS: '/fd/tcp-shares/certificate-request-tokens',
    FD_TCP_SHARES_SERVER_CERTIFICATES: '/fd/tcp-shares/server-certificates',
    FD_TCP_SHARES_SERVER_CERTIFICATES_CREATE: '/fd/tcp-shares/server-certificates/create',
    FD_TCP_SHARES_SERVER_CERTIFICATE_REQUESTS: '/fd/tcp-shares/server-certificate-requests',
    FD_TCP_SHARES_SERVER_CERTIFICATE_REQUESTS_CREATE: '/fd/tcp-shares/server-certificate-requests/create',
    FD_TCP_SHARES_TOKENS_CREATE: '/fd/tcp-shares/certificate-request-tokens/create',
    FD_AGENTS: '/fd/agents',
    FD_AGENTS_CREATE: '/fd/agents/create',
    // The IPsec section: one page with two tabs, the shares reached over a tunnel and the tunnels
    // themselves, so the tab is a query parameter on the section's own url.
    FD_IPSEC: '/fd/ipsec',
    FD_IPSEC_SHARES: '/fd/ipsec',
    FD_IPSEC_TUNNELS: '/fd/ipsec?tab=tunnels',
    FD_IPSEC_SHARES_CREATE: '/fd/ipsec/shares/create',
    FD_IPSEC_TUNNELS_CREATE: '/fd/ipsec/tunnels/create',
    FD_PROCESSES: '/fd/processes',
    FD_ALERTS: '/fd/alerts',
    FD_AUDIT_EVENTS: '/fd/audit-events',
    FD_OPERATIONS_HTTP: '/fd/operations/http-ingress',
    FD_OPERATIONS_MTLS: '/fd/operations/mtls-ingress',
    FD_OPERATIONS_MANAGEMENT: '/fd/operations/management',
    FD_SETTINGS: '/fd/settings',
    FD_SETTINGS_AI_ASSISTANT: '/fd/settings/ai-assistant',
    FRONTDOOR: '/frontdoor',
    FRONTDOOR_HTTP: '/frontdoor/http-shares',
    FRONTDOOR_TCP: '/frontdoor/tcp-shares',
    FRONTDOOR_LOGS: '/frontdoor/logs',
    FRONTDOOR_METRICS: '/frontdoor/metrics',
    FRONTDOOR_CREATE: '/frontdoor/create',
    FRONTDOOR_EDIT: '/frontdoor/:name',
    FRONTDOOR_DASHBOARD: '/frontdoor/dashboard',
    FRONTDOOR_DOWNLOADS: '/frontdoor/downloads',
    FRONTDOOR_HEALTH_CHECKS: '/frontdoor/health-checks',
    FRONTDOOR_AGENTS: '/frontdoor/agents',
    FRONTDOOR_CLIENT_CERTIFICATES: '/frontdoor/client-certificates',
    FRONTDOOR_FRONTENDS: '/frontdoor/frontends',
    FRONTDOOR_NAMESPACES: '/frontdoor/namespaces',
    FRONTDOOR_IPSEC_TUNNELS: '/frontdoor/ipsec-tunnels',
    FRONTDOOR_IPSEC_SHARES: '/frontdoor/ipsec-shares',
    FRONTDOOR_AUTH_PROVIDERS: '/frontdoor/authentication',
    FRONTDOOR_PROCESS_EXECUTIONS: '/frontdoor/change-log',
    FRONTDOOR_TOKENS: '/frontdoor/certificate-request-tokens',
    FRONTDOOR_CLIENT_CERTIFICATES_CSR: '/frontdoor/certificate-upload',
    FRONTDOOR_CLIENT_CERTIFICATES_CSR_V2: '/frontdoor/v2/certificate-upload',
    // The v3 upload page. The link to it carries the enrollment JWT in its fragment, so it takes
    // no frontdoorId or token of its own.
    FRONTDOOR_CLIENT_CERTIFICATES_CSR_V3: '/frontdoor/v3/certificate-upload',
    // The public page that the certificate-expiring email links to, with ?frontdoorId= and ?certificateId=.
    FRONTDOOR_CLIENT_CERTIFICATES_RENEW: '/frontdoor/certificate-renew',
    ON_PREM: '/self-hosted',
    ON_PREM_LIST: '/self-hosted/list',
    IPSEC_TUNNELERS: '/network/ipsec-tunnelers',
    IPSEC_TUNNELERS_LIST: '/network/ipsec-tunnelers/list',
};

export const INFRASTRUCTURE_URLS = {
    DASHBOARD: '/network/dashboard',
    OVERVIEW: '/network/overview',
    ROUTERS: '/infrastructure/routers',
    MANAGED_ROUTERS: '/network/edge-routers',
    MANAGED_ROUTERS_LIST: '/network/edge-routers/list',
    METRICS: '/infrastructure/metrics',
    NETWORKS: '/infrastructure/networks',
    NETWORK_GROUPS: '/infrastructure/network-groups',
    OPERATIONS: '/network/operations',
    OPERATIONS_BACKUPS: '/network/operations/backups',
    OPERATIONS_SUPPORT_INFO: '/network/operations/support-info',
    OPERATIONS_UPGRADES: '/network/operations/upgrades',
    SETTINGS: '/network/settings',
    SETTINGS_AI_ASSISTANT: '/network/settings/ai-assistant',
    SETTINGS_FIREWALL_INFO: '/network/settings/firewall-info',
};

export const ZITI_URLS = {
    ZITI_DASHBOARD: '/dashboard',
    ZITI_IDENTITIES: '/identities',
    ZITI_IDENTITIES_LIST: '/identities/list',
    ZITI_JWT_SIGNERS: '/jwt-signers',
    ZITI_JWT_SIGNERS_LIST: '/jwt-signers/list',
    ZITI_SERVICES: '/services',
    ZITI_SERVICES_LIST: '/services/list',
    ZITI_ROUTERS: '/routers',
    ZITI_ROUTERS_LIST: '/routers/list',
    ZITI_TRANSIT_ROUTERS: '/transit-routers',
    ZITI_TRANSIT_ROUTERS_LIST: '/transit-routers/list',
    ZITI_CONFIGS: '/configs',
    ZITI_CONFIGS_LIST: '/configs/list',
    ZITI_CONFIG_TYPES: '/config-types',
    ZITI_CONFIG_TYPES_LIST: '/config-types/list',
    ZITI_RECIPES: '/recipes',
    ZITI_TERMINATORS: '/terminators',
    ZITI_TERMINATORS_LIST: '/terminators/list',
    ZITI_AUTH_POLICIES: '/auth-policies',
    ZITI_AUTH_POLICIES_LIST: '/auth-policies/list',
    ZITI_SERVICE_POLICIES: '/service-policies',
    ZITI_SERVICE_POLICIES_LIST: '/service-policies/list',
    ZITI_ROUTER_POLICIES: '/router-policies',
    ZITI_ROUTER_POLICIES_LIST: '/router-policies/list',
    ZITI_SERVICE_ROUTER_POLICIES: '/service-router-policies',
    ZITI_SERVICE_ROUTER_POLICIES_LIST: '/service-router-policies/list',
    ZITI_POSTURE_CHECKS: '/posture-checks',
    ZITI_POSTURE_CHECKS_LIST: '/posture-checks/list',
    ZITI_CERT_AUTHORITIES: '/certificate-authorities',
    ZITI_CERT_AUTHORITIES_LIST: '/certificate-authorities/list',
    ZITI_SESSIONS: '/sessions',
    ZITI_SESSIONS_LIST: '/sessions/list',
    ZITI_API_SESSIONS: '/api-sessions',
    ZITI_API_SESSIONS_LIST: '/api-sessions/list',
    ZITI_LOGIN: '/login',
    ZITI_ORGANIZATION: '/organization',
    ZITI_PROFILE: '/profile',
    ZITI_SERVERS: '/servers',
    ZITI_SETTINGS: '/settings',
    ZITI_SERVICE_TEMPLATES: '/service-templates',
    ZITI_SERVICE_TEMPLATES_LIST: '/service-templates/list',
};

// Legacy ziti list URL -> redesigned (beta) list URL. First path segment must match the legacy URL
// (the lib builds detail links as /<firstSegment>/<id>).
export const ZITI_BETA_LIST_ROUTES: Record<string, string> = {
    [ZITI_URLS.ZITI_IDENTITIES]: ZITI_URLS.ZITI_IDENTITIES_LIST,
    [ZITI_URLS.ZITI_SERVICES]: ZITI_URLS.ZITI_SERVICES_LIST,
    [ZITI_URLS.ZITI_ROUTERS]: ZITI_URLS.ZITI_ROUTERS_LIST,
    [ZITI_URLS.ZITI_TRANSIT_ROUTERS]: ZITI_URLS.ZITI_TRANSIT_ROUTERS_LIST,
    [ZITI_URLS.ZITI_SERVICE_POLICIES]: ZITI_URLS.ZITI_SERVICE_POLICIES_LIST,
    [ZITI_URLS.ZITI_ROUTER_POLICIES]: ZITI_URLS.ZITI_ROUTER_POLICIES_LIST,
    [ZITI_URLS.ZITI_SERVICE_ROUTER_POLICIES]: ZITI_URLS.ZITI_SERVICE_ROUTER_POLICIES_LIST,
    [ZITI_URLS.ZITI_POSTURE_CHECKS]: ZITI_URLS.ZITI_POSTURE_CHECKS_LIST,
    [ZITI_URLS.ZITI_JWT_SIGNERS]: ZITI_URLS.ZITI_JWT_SIGNERS_LIST,
    [ZITI_URLS.ZITI_TRANSIT_ROUTERS]: ZITI_URLS.ZITI_TRANSIT_ROUTERS_LIST,
    [ZITI_URLS.ZITI_CONFIGS]: ZITI_URLS.ZITI_CONFIGS_LIST,
    [ZITI_URLS.ZITI_CONFIG_TYPES]: ZITI_URLS.ZITI_CONFIG_TYPES_LIST,
    [ZITI_URLS.ZITI_TERMINATORS]: ZITI_URLS.ZITI_TERMINATORS_LIST,
    [ZITI_URLS.ZITI_AUTH_POLICIES]: ZITI_URLS.ZITI_AUTH_POLICIES_LIST,
    [ZITI_URLS.ZITI_CERT_AUTHORITIES]: ZITI_URLS.ZITI_CERT_AUTHORITIES_LIST,
    [ZITI_URLS.ZITI_SESSIONS]: ZITI_URLS.ZITI_SESSIONS_LIST,
    [ZITI_URLS.ZITI_API_SESSIONS]: ZITI_URLS.ZITI_API_SESSIONS_LIST,
    [ZITI_URLS.ZITI_SERVICE_TEMPLATES]: ZITI_URLS.ZITI_SERVICE_TEMPLATES_LIST,
    [URLS.NETWORK_CONTROLLERS]: URLS.NETWORK_CONTROLLERS_LIST,
    [URLS.ALLOCATED_IPS]: URLS.ALLOCATED_IPS_LIST,
    [URLS.IPSEC_TUNNELERS]: URLS.IPSEC_TUNNELERS_LIST,
    [URLS.SCIM]: URLS.SCIM_LIST,
    [URLS.PROCESS_EXECUTIONS]: URLS.PROCESS_EXECUTIONS_LIST,
    [URLS.MANAGEMENT_EVENTS]: URLS.MANAGEMENT_EVENTS_LIST,
    [URLS.NETWORK_EVENTS]: URLS.NETWORK_EVENTS_LIST,
    [URLS.NOTIFICATIONS]: URLS.NOTIFICATIONS_LIST,
    [URLS.OLD_NETWORK]: URLS.OLD_NETWORK_LIST,
    [URLS.NETWORKS_COMBINED]: URLS.OLD_NETWORK_LIST,
    [URLS.USERS]: URLS.USERS_LIST,
    [URLS.USER_ROLES]: URLS.USER_ROLES_LIST,
    [URLS.ROLE_TEMPLATES]: URLS.ROLE_TEMPLATES_LIST,
    [URLS.TOKENS]: URLS.TOKENS_LIST,
    [URLS.MANAGE_INVITATIONS]: URLS.MANAGE_INVITATIONS_LIST,
    [URLS.STORED_SECRETS]: URLS.STORED_SECRETS_LIST,
    [URLS.ORGANIZATIONS]: URLS.ORGANIZATIONS_LIST,
    [URLS.OIDC_ISSUERS]: URLS.OIDC_ISSUERS_LIST,
    [URLS.OIDC_AUDIENCES]: URLS.OIDC_AUDIENCES_LIST,
    [URLS.OIDC_IDENTITY_AUDIENCE_MAP]: URLS.OIDC_IDENTITY_AUDIENCE_MAP_LIST,
    [URLS.OIDC_PUBLIC_CLIENT_ORG_MAPPING]: URLS.OIDC_PUBLIC_CLIENT_ORG_MAPPING_LIST,
    [INFRASTRUCTURE_URLS.MANAGED_ROUTERS]: INFRASTRUCTURE_URLS.MANAGED_ROUTERS_LIST,
    [URLS.CUSTOMERS]: URLS.CUSTOMERS_LIST,
    [URLS.CUSTOMER_PROCESS_EXECUTIONS]: URLS.CUSTOMER_PROCESS_EXECUTIONS_LIST,
    [URLS.ON_PREM]: URLS.ON_PREM_LIST,
};
